
import React, {Component} from 'react'
import CategoriesBar from './CategoriesBar'
import CategoryItems from './CategoryItems'
import OrderDetails from './OrderDetails'
import VToolbar from './components/details/VToolbar'
import VoucherCodeApplierDialogue from './components/misc/VoucherCodeApplierDialogue'

var stringUtil = require('../../utils/string/stringUtil');

class OrderView extends Component 
{
    constructor(props)
    {
        super(props);

        this.onKeyDown = this.onKeyDown.bind(this);
        this.onEnteringVoucher = this.onEnteringVoucher.bind(this);
        this.renderVoucherScannerDialogue = this.renderVoucherScannerDialogue.bind(this);

        this.state = {};
        this.state.rawQRCode = "";
        this.state.showQRDialogue = false;
    }

    onKeyDown(event)
    {
        if (event.keyCode <= 20)
        {
            if (event.keyCode == 13)
            {
                if (stringUtil.isStringNullOrEmpty(this.state.rawQRCode))
                    return;

                this.state.showQRDialogue = true;
                this.setState({});
            }
            
            return;
        }

        this.state.rawQRCode = this.state.rawQRCode + "" + event.key;
    }

    render()
    {
        return <div className='h-100 w-100' style={{background:'var(--background-color)'}} tabIndex={0} onKeyDown={this.onKeyDown}>
                    <table className='h-100 w-100'>
                        <tr className='h-100 w-100'>
                            <td className='h-100' style={{width:'65%'}}>
                                <table className='h-100 w-100'>
                                    <tr>
                                        <td style={{verticalAlign:'top'}}>
                                            <CategoriesBar/>
                                        </td>
                                    </tr>
                                    <tr className='h-100 w-100'>
                                        <td style={{verticalAlign:'top'}}>
                                            <CategoryItems/>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td className='h-100' style={{width:'5%'}}>
                                <VToolbar onEnteringVoucher={this.onEnteringVoucher}/>
                            </td>
                            <td className='h-100' style={{verticalAlign:'top', width:'30%', padding:"12px", background: "white"}}>
                                <OrderDetails/>
                            </td>
                        </tr>

                    </table>
                    {this.renderVoucherScannerDialogue()}
               </div>
    }

    onEnteringVoucher(voucherCode)
    {
        this.state.rawQRCode = `com.flipdish.qr.voucher.${voucherCode}`
        this.state.showQRDialogue = true;
        this.setState({});    
    }

    renderVoucherScannerDialogue()
    {
        if (!this.state.showQRDialogue || stringUtil.isStringNullOrEmpty(this.state.rawQRCode))
            return null;

        let qrCode = this.state.rawQRCode;
        this.state.rawQRCode = "";

        if (!qrCode.startsWith("com.flipdish.qr.voucher."))
            return null;

        qrCode = stringUtil.replaceAll(qrCode, "com.flipdish.qr.voucher.", "");
        if (stringUtil.isStringNullOrEmpty(qrCode))
            return null;

        return <VoucherCodeApplierDialogue qrCode={qrCode}
                    onFinish={()=>
                    {
                        this.state.showQRDialogue = false;
                        this.setState({})
                    }}/>
    }
}

export default OrderView